module.exports = __webpack_public_path__ + "static/media/tooth-build-alt.393d5ba4.png";